import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { openModal, closeModal, setOptions as setOptionsAction } from '../redux/modalSlice';

export function useModal() {
  const state = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const open = useCallback((modal) => {
    if (typeof modal === 'object' && !('content' in modal)) {
      modal = { content: modal };
    }
    dispatch(openModal(modal));
  }, []);

  const close = useCallback(() => {
    dispatch(closeModal());
  }, []);

  const setOptions = useCallback((options) => {
    dispatch(setOptionsAction(options));
  }, []);

  return { open, close, setOptions, modal: state };
}